import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SecurityDoc } from './../_models/securityDoc';
import { environment } from './../../../environments/environment';

@Injectable()
export class SecurityDocService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getSecurityDocs(): Observable<SecurityDoc[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/securityDocs')
      .pipe(map((response) => response));
  }

  getSecurityDoc(id: number): Observable<SecurityDoc> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/securityDocs/' + id)
      .pipe(map((response) => response));
  }

  saveSecurityDoc(securityDocItem): Observable<SecurityDoc> {
    const securityDoc = { ...securityDocItem };
    delete securityDoc.lastUpdated;
    delete securityDoc.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    securityDoc.companyId = companySelected ? companySelected.id : null;

    if (securityDoc.id) {
      return this.http
        .put<SecurityDoc>(
          this.apiBaseUrl + 'api/private/v1/securityDocs/' + securityDoc.id,
          securityDoc
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<SecurityDoc>(this.apiBaseUrl + 'api/private/v1/securityDocs/', securityDoc)
        .pipe(map((response) => response));
    }
  }

  deleteSecurityDoc(id: number): Observable<SecurityDoc> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/securityDocs/' + id).pipe(
      map((response) => {
        return { id } as SecurityDoc;
      })
    );
  }
}
